if (!customElements.get('balance-faq-accordion')) {
  customElements.define(
    'balance-faq-accordion',
    class BalanceFaqAccordion extends HTMLElement {
      connectedCallback() {
        this.triggers = Array.from(this.querySelectorAll('.balance-faq__trigger'));

        this.onClick = this.onClick.bind(this);
        this.triggers.forEach((trigger) => trigger.addEventListener('click', this.onClick));
      }

      disconnectedCallback() {
        this.triggers.forEach((trigger) => trigger.removeEventListener('click', this.onClick));
      }

      onClick(event) {
        const trigger = event.currentTarget;
        const card = trigger.closest('.balance-faq__card');
        const panel = document.getElementById(trigger.getAttribute('aria-controls'));
        const nextOpen = trigger.getAttribute('aria-expanded') !== 'true';

        if (!card || !panel) return;

        trigger.setAttribute('aria-expanded', String(nextOpen));
        card.classList.toggle('is-open', nextOpen);
        panel.hidden = !nextOpen;
      }
    }
  );
}
